import React from 'react';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import { createTabScreen } from 'src/navigation/primaryNav/createTabScreen';
import { RootTab } from 'src/navigation/TabNavigation';
import withSuspense from 'src/navigation/withSuspense';
const Home = withSuspense(React.lazy(async () => {
    return import('./screens/Home');
}));
export const notificationNavEntry = {
    id: 'notification',
    prefix: 'Notification_',
    to: { screen: 'Notification_Home', params: {} },
    label: ({ translate }) => translate('Notifications'),
    renderIcon: (color, size) => (React.createElement(FeatherIcon, { name: "bell", color: color, size: size })),
    badge: ({ unreadCount }) => unreadCount,
    isVisible: ({ isRegistered }) => isRegistered,
    placements: ['tab', 'sidebar-main'],
    renderTabRoutes(ctx) {
        return (React.createElement(RootTab.Group, null, createTabScreen(notificationNavEntry, ctx, 'Notification_Home', Home)));
    },
};
export function renderNotificationTabRoutes(ctx) {
    return notificationNavEntry.renderTabRoutes(ctx);
}
